import React, { useState, useEffect } from "react"

import {
  Card,
  CardBody,
  Col,
  Row,
  CardTitle,
  Alert,
  Label,
  Input,
  Button,
  Modal,
  ModalBody
} from "reactstrap"

import { AvForm, AvField } from "availity-reactstrap-validation"
import { post, put, get } from '../../helpers/api_helper';
import Utils from '../Utility';
import { toast } from 'react-toastify';

const AddLeadForm = (props) => {
  const { user, data, role, loading, setLoading, selectedDay } = props;
  const [descLength, setDescLength] = useState(data ? data?.title.length : 0);
  const [isUserAdding, setIsUserAdding] = useState(false);

  const getFormatedTime = (time) => {
    if (time) {
      let temp = time.split(" ");
      let temp2 = temp[0];
      if (temp[1] == 'pm') {
        let temp3 = temp2.split(":");
        if (Number(temp3[0]) != 12)
          temp2 = 12 + Number(temp3[0]) + ":" + temp3[1];
        else
          temp2 = temp3[0] + ":" + temp3[1];
      }
      return temp2;
    } else {
      return "09:00";
    }
  }

  const getFormatedTimeForDB = (time) => {
    console.log('time to format', time);
    let temp = time.split(":");
    let temp2 = time + " am";
    if (Number(temp[0]) > 11) {
      // console.log('need to add pm', temp[0]);
      if (Number(temp[0]) > 12)
        temp2 = String(Number(temp[0]) - 12).padStart(2, "0") + ":" + temp[1] + " pm";
      else {
        temp2 = time + " pm";
      }
    } else if (Number(temp[0]) == 0) {
      temp2 = "12:" + temp[1] + " pm";
    }
    // console.log('modifying time', temp2);
    return temp2;
  }

  function handleValidSubmit(event, values) {
    console.log('values from form', getFormatedTimeForDB(values?.startAt));
    if (user) {
      if (data) {
        //updating user
        const body = {
          ...values,
          token: user?.token,
          slotId: data?._id,
          startAt: getFormatedTimeForDB(values?.startAt),
          endAt: getFormatedTimeForDB(values?.endAt),
          dayId: selectedDay?._id
        };
        setLoading(true);
        let url = "/slot/update";
        put(url, body)
          .then((json) => {
            console.log('response from updating lead', json);
            setLoading(false);
            if (json.statusCode == 200) {
              toast.success(json?.message);
              props?.getData();
              props.close(false);
            }
          })
          .catch(error => {
            toast.error(error);
            console.error('error while updating slot', error);
            setLoading(false);
          })
      } else {
        //adding new user
        const body = {
          ...values,
          token: user?.token,
          startAt: getFormatedTimeForDB(values?.startAt),
          endAt: getFormatedTimeForDB(values?.endAt)
        };
        setLoading(true);
        let url = "/slot/add";
        post(url, body)
          .then((json) => {
            console.log('response from adding slot', json);
            setLoading(false);
            if (json.statusCode == 200) {
              toast.success(json?.message);
              props?.getData();
              props.close(false);
            }
          })
          .catch(error => {
            toast.error(error);
            console.error('error while adding slot', error);
            setLoading(false);
          })
      }
    } else {
      toast.error('Unauthorized!');
    }
  }

  return (
    <React.Fragment>
      <div className="">
        <Row>
          <Col>
            <Card>
              <CardBody>
                <div className="">
                  <div className="d-flex" style={{ marginLeft: 'auto' }}>
                    <div style={{ textAlign: 'left' }}>
                      <CardTitle className="h4">{data ? 'Update' : 'Add New'} {role}</CardTitle>
                      <p className="card-title-desc">
                        This <code>{role}</code> Will be {data ? 'updated' : 'added'} to your <code>{role}s</code> and can be managed from here.
                      </p>
                    </div>
                    <div className="text-center" style={{ marginLeft: 'auto' }}>
                      <Button color="primary" onClick={() => { props?.close(false) }} style={{ background: `linear-gradient(135deg, ${user?.company?.theme ? user?.company?.theme : Utils.themeColor} 0%, #8b0000 100%)`, border: 'none' }}>
                        Close
                      </Button>
                    </div>
                  </div>
                  <AvForm
                    className="form-horizontal"
                    onValidSubmit={(e, v) => {
                      handleValidSubmit(e, v)
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="form-group mb-4">
                          <AvField
                            name="startAt"
                            label={"Start Time"}
                            value={getFormatedTime(data?.startAt)}
                            className="form-control"
                            placeholder={`Select Start Time`}
                            type="time"
                            required
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="form-group mb-4">
                          <AvField
                            name="endAt"
                            label={"End Time"}
                            value={getFormatedTime(data?.endAt)}
                            className="form-control"
                            placeholder={`Select End Time`}
                            type="time"
                            required
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="form-group mb-4">
                      <AvField
                        name="title"
                        label={"Description"}
                        value={data?.title}
                        className="form-control"
                        placeholder={`Enter Description`}
                        type="textarea"
                        required
                        validate={{ maxLength: { value: 200 } }}
                        onChange={(t) => setDescLength(t.target.value.length)}
                      />
                    </div>
                    <div className="mt-3" style={{ textAlign: 'end' }}>
                      <p>{descLength}/200</p>
                    </div>
                    {/* <AvField name="idx" value={user?.company._id} type="hidden" /> */}
                    <div className="text-center mt-4">
                      {data ?
                        <Button type="submit" color="primary" style={{ background: `linear-gradient(135deg, ${user?.company?.theme ? user?.company?.theme : Utils.themeColor} 0%, #8b0000 100%)`, border: 'none' }}>
                          Update {props.role}
                        </Button>
                        :
                        <Button type="submit" color="primary" style={{ background: `linear-gradient(135deg, ${user?.company?.theme ? user?.company?.theme : Utils.themeColor} 0%, #8b0000 100%)`, border: 'none' }}>
                          Add {props.role}
                        </Button>
                      }
                    </div>
                  </AvForm>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default AddLeadForm;
